import { render, staticRenderFns } from "./HistoryAlarmTable.vue?vue&type=template&id=fb6479c2&"
import script from "./HistoryAlarmTable.vue?vue&type=script&lang=js&"
export * from "./HistoryAlarmTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports